import React from 'react';
import { Flex, Text, Icon } from '@spothero/ui';
import IconFlameFilled from '@spothero/icons/flame-filled';
const AVAILABLE_SPACES_THRESHOLD = 5;
export const shouldShowPriceUrgencyCallout = (tieredAvailability, availability, isShowSpotsLeftVisible) => {
    if (!tieredAvailability || isShowSpotsLeftVisible) {
        return false;
    }
    if (availability &&
        availability.availableSpaces <= AVAILABLE_SPACES_THRESHOLD) {
        return false;
    }
    const { currentTierInventoryRemaining, nextTierPriceDifference = 0, } = tieredAvailability;
    if (nextTierPriceDifference <= 0) {
        return false;
    }
    return currentTierInventoryRemaining <= AVAILABLE_SPACES_THRESHOLD;
};
const PriceUrgencyCallout = ({ tieredAvailability, availability, isShowSpotsLeftVisible = false, }) => {
    if (!shouldShowPriceUrgencyCallout(tieredAvailability, availability, isShowSpotsLeftVisible)) {
        return null;
    }
    const { currentTierInventoryRemaining } = tieredAvailability;
    return (<Flex align="center" gap="1" justifyContent="flex-end" minWidth="75px" mb="1" color="red.default">
            <Icon as={IconFlameFilled} boxSize="4" width="4" height="4"/>
            <Text fontSize="sm" fontWeight="semibold">
                {currentTierInventoryRemaining} left at
            </Text>
        </Flex>);
};
export default PriceUrgencyCallout;
